<template>
  <div id="app">
    <div class="app-loaded">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
//amplify
import { components } from 'aws-amplify-vue';
import store from './store/store';

export default {
  name: 'app',
  data() {
    return {};
  },
  store,
  components: {
    ...components,
  },
  async mounted() {
    sessionStorage.setItem('sessionId', Date.now());
  },
};
</script>

<style>
@font-face {
  font-family: 'Aktiv Grotesk';
  src: url('https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/fonts/AktivGroteskCorp-Regular.woff2')
      format('woff2'),
    url('https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/fonts/AktivGroteskCorp-Regular.woff')
      format('woff'),
    url('https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/fonts/AktivGroteskCorp-Regular.ttf')
      format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'Aktiv Grotesk';
  src: url('https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/fonts/AktivGroteskCorp-Medium.woff2')
      format('woff2'),
    url('https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/fonts/AktivGroteskCorp-Medium.woff')
      format('woff'),
    url('https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/fonts/AktivGroteskCorp-Medium.ttf')
      format('truetype');
  font-weight: 500;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'AktivGroteskMedium';
  font-weight: 400;
  src: url('https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/fonts/AktivGrotesk-Medium.otf')
      format('openType'),
    url('https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/fonts/AktivGrotesk-Medium.ttf')
      format('truetype');

  font-display: block;
}
@font-face {
  font-family: 'Avenir Next';
  src: url('https://codelosio-assets.s3.eu-central-1.amazonaws.com/public-assets/fonts/AvenirNext-similar-Heavy.woff2')
      format('woff2'),
    url('https://codelosio-assets.s3.eu-central-1.amazonaws.com/public-assets/fonts/AvenirNext-similar-Heavy.woff')
      format('woff'),
    url('https://codelosio-assets.s3.eu-central-1.amazonaws.com/public-assets/fonts/AvenirNext-similar-Heavy.ttf')
      format('truetype');
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'OpenSans-Bold';
  src: url('https://codelosio-assets.s3.eu-central-1.amazonaws.com/public-assets/fonts/OpenSans-Bold.woff2')
      format('woff2'),
    url('https://codelosio-assets.s3.eu-central-1.amazonaws.com/public-assets/fonts/OpenSans-Bold.woff')
      format('woff');
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'OpenSans-Regular';
  src: url('https://codelosio-assets.s3.eu-central-1.amazonaws.com/public-assets/fonts/OpenSans-Regular.woff2')
      format('woff2'),
    url('https://codelosio-assets.s3.eu-central-1.amazonaws.com/public-assets/fonts/OpenSans-Regular.woff')
      format('woff');
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: 'OpenSans-SemiBold';
  src: url('https://codelosio-assets.s3.eu-central-1.amazonaws.com/public-assets/fonts/OpenSans-SemiBold.woff2')
      format('woff2'),
    url('https://codelosio-assets.s3.eu-central-1.amazonaws.com/public-assets/fonts/OpenSans-SemiBold.woff')
      format('woff');
  font-style: normal;
  font-display: block;
}

:root {
  --primary-color: 0, 0, 0;
  --primary-font: 'Aktiv Grotesk';
}
html {
  height: 100%;
}

body {
  display: block;
  margin: 0;
  font-family: 'Open Sans', open-sans, sans-serif;
  height: 100%;
}
.font-aktiv-grotesk,
.workflow-font-family {
  font-family: var(--primary-font) !important;
}

body.modal-open {
  overflow: hidden;
}

#app {
  height: 100%;
}

.app-loaded {
  height: 100%;
}

html:root {
  --amazonOrange: #ff3366;
  --button-background-color: #ff3366;
  --green: #09baa6;
  --green-darker: #00a08e;
  --link-color: none;
}

/* custom scrollbar*/
/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #ffff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(117 117 117);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: none !important;
  background-color: transparent;
}

::-webkit-scrollbar {
  width: 7px !important;
  background-color: transparent;
}
.modal .btn-close {
  background-image: url(/img/modal-sprite.67649c98.png);
  background-size: 1293px 1277px;
  background-position: -1278px -577px;
  cursor: pointer;
  border-radius: unset;
  box-shadow: none;
  width: 15px;
  height: 15px;
  padding: 0;
}
.btn-close {
  cursor: pointer;
}

/*Utility Classes */

.pl-30,
.px-30 {
  padding-left: 30px !important;
}
.pr-30,
.px-30 {
  padding-right: 30px !important;
}
.pt-30,
.py-30 {
  padding-top: 30px !important;
}
.pb-30,
.py-30 {
  padding-bottom: 30px !important;
}

.pl-45,
.px-45 {
  padding-left: 45px !important;
}
.pr-45,
.px-45 {
  padding-right: 45px !important;
}
.pt-45,
.py-45 {
  padding-top: 45px !important;
}
.pb-45,
.py-45 {
  padding-bottom: 45px !important;
}

/* tooltip text center */
.b-tooltip .tooltip-inner {
  padding-top: 6px;
}
.collapsible-icon {
  font-size: 15px;
  font-weight: 400;
}
.navbar-tree-view .left-menu-list-name a {
  color: #333343 !important;
  font-size: 15px;
  font-weight: 400;
}

/* .tooltip.b-tooltip .tooltip-inner  CLASS FOR OVERALL TOOLTIP*/
.codelos-tooltip .tooltip-inner {
  background-color: white !important;
  font-size: 14px !important;
  color: #333343 !important;
  border-radius: 5px !important;
  border: 1px solid #efefef !important;
  padding: 8px 12px;
}

.codelos-tooltip.delete-flow-tooltip {
  margin-right: 20px;
}
.b-toaster {
  z-index: 9999 !important;
}
.b-toaster .b-toast .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}

.b-toaster .b-toast .toast:not(.show) {
  display: block;
  box-shadow: 0px 0rem 21px #00000014;
}

.b-toaster .b-toast .toast-header,
.b-toaster .b-toast .toast-body {
  padding: 16px;
}
.b-toaster .b-toast.b-toast-danger .toast-header {
  background-color: #feecec !important;
  border-color: #feecec !important;
  color: #6d1111 !important;
}
.b-toaster .b-toast.b-toast-success .toast-header {
  background-color: #e6f4ea !important;
  border-color: #e6f4ea !important;
  color: #2e7d32 !important;
}
.b-toaster .b-toast .toast-body {
  color: #5a5a5a !important;
  background-color: white !important;
}

.b-toaster .b-toast .toast {
  border-color: unset !important;
  border: none !important;
  border-radius: 10px;
  overflow: hidden;
}

.custom-range-input {
  -webkit-appearance: none !important;
  appearance: none !important;
  outline: none !important;
}

.custom-range-input::-webkit-slider-runnable-track {
  background: #000 !important;
  border: none !important;
  border-radius: 3px !important;
  height: 6px !important;
}

.custom-range-input:focus {
  border: 1.2px solid #b1b4b8 !important;
}

.custom-range-input::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  appearance: none !important;
  width: 28px !important;
  height: 28px !important;
  background: #fff !important;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -12px;
  border: 1px solid #eee;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}

.fancy-scroll::-webkit-scrollbar {
  width: 4px;
}

.fancy-scroll::-webkit-scrollbar-track {
  border-radius: 7px;
  background-color: transparent;
  border: 1px solid transparent;
}

.fancy-scroll::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background-color: #565656;
}

@media screen and (max-width: 1366px) {
  .fancy-scroll::-webkit-scrollbar-thumb {
    display: none;
  }
}

.show-scrollbar::-webkit-scrollbar-thumb {
  display: block;
}

.popover.b-popover .popover-body {
  padding: 10px;
  font-size: 16px;
  line-height: 1.2;
  max-width: 100%;
  width: 200px;
}

.popover.b-popover.more-active-users-popover {
  width: 400px;
}
.popover.b-popover.more-active-users-popover .popover-body {
  width: 100% !important;
}

.code-task-library-tooltip {
  top: 130px !important;
  right: 0px !important;
  left: auto !important;
  transform: translate3d(0px, 0px, 0px) !important;
}

.code-task-library-tooltip .tooltip_wrapper ul {
  max-height: 60dvh;
  overflow-y: auto;
}

.b-tooltip.supported-file-type .tooltip-inner {
  background-color: #333343;
  padding: 0 !important;
  opacity: 1 !important;
}

.b-tooltip.supported-file-type {
  padding: 0 !important;
  top: -5px !important;
  opacity: 1 !important;
}
</style>
